module.exports = __webpack_public_path__ + "img/2_2.e7244bab.png";